import * as React from 'react';

interface IProgressProps {
	percent: number;
	numericDisplay?: boolean; // default true
}

export const Progress: React.FC<IProgressProps> = ({ percent, numericDisplay }) => {
	if (numericDisplay === undefined) {
		numericDisplay = true;
	}
	return <div className={`progress progress--${percent >= 55}`}>
		<span className="progress__bar" style={{ width: `${percent || 0}%` }}></span>
		{numericDisplay && <span className="progress__text">{`${percent}%`}</span>}
	</div>;
};
